import api from '@/api/transactions';

const sendFeedback = (context, payload) => new Promise(((resolve, reject) => {
  api.sendFeedback(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const filter = (context, payload) => new Promise(((resolve, reject) => {
  api.filter(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const popularReasons = (context, payload) => new Promise(((resolve, reject) => {
  api.popularReasons(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const recommendation = (context, payload) => new Promise(((resolve, reject) => {
  api.recommendation(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

export default {
  sendFeedback,
  filter,
  popularReasons,
  recommendation,
};

